export class ProductUseValidity {
  private key: string;
  private useType: string;

  public getKey(): string {
    return this.key;
  }

  public setKey(value: string): void {
    this.key = value;
  }

  public getUseType(): string {
    return this.useType;
  }

  public setUseType(value: string): void {
    this.useType = value;
  }
}
